import React from "react";
import { Stepper, Step, StepLabel, Typography, Box } from "@mui/material";
import { IoTime } from "react-icons/io5";
import { FaShip } from "react-icons/fa";
import { MdPeople } from "react-icons/md";

const steps = [
  { label: "SELECT DATE", icon: <IoTime /> },
  { label: "SELECT CRUISE TIME", icon: <FaShip /> },
  { label: "BOOKING NOW", icon: <MdPeople /> },
];

function CustomStepper({ currentStep }) {
  return (
    <Box
      sx={{
        width: "98%",
        margin: 4,
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "25px auto 0px auto",
      }}
    >
      <Stepper
        sx={{
          width: "100%",
          backgroundColor: "#eff5f7",
          borderRadius: "15px 15px 0px 0px",
        }}
      >
        {steps.map((step, index) => (
          <Step
            key={step.label}
            active={index <= currentStep}
            sx={{
              borderBottom:
                index <= currentStep
                  ? "7px solid #55D0E4"
                  : "7px solid #dfdfdf",              
              width: "100%",
              textAlign: "center",
              margin: index === 1 ? "0px 10px" : "0px",
              padding: "10px 0px 6px 0px",
              fontSize: "20px",
            }}
          >
            <Typography
              variant="caption"
              fontWeight="bold"              
              fontSize={'18px'}
              sx={{ fontFamily: "STIX Two Text",
                letterSpacing: '3px',
              color:
                index <= currentStep
                  ? "#23BFD2"
                  : "#4c4c4c", }}
            >
              {step.label}
            </Typography>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default CustomStepper;
